const userLocation = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const location = await response.json();
    return location?.currency;
  } catch (error) {
    return error;
  }
};

export default userLocation;
